export default __webpack_public_path__ + "static/media/bg7.1a650964.png";